module.exports = __webpack_public_path__ + "img/introductionBlue.b18c7b99.jpg";